import { useEffect, useState } from 'react';

import { isAppleMobileDevice } from '@/domains/customerFinanceOperations/Payment/components/PaymentMethods/StandaloneApplePay/utils/isAppleMobileDevice';

export const useApplePayIcons = (paymentMethods?: string[]) => {
  const isAppleDevice = isAppleMobileDevice();
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);

  useEffect(() => {
    // window.ApplePaySession is only available with devices/browser that support Apple Pay
    if (isAppleDevice && window?.ApplePaySession) {
      const applePayMethodIsAvailable = paymentMethods
        ? paymentMethods.some((el) => el.startsWith('apple_pay_'))
        : true;

      setIsApplePayAvailable(applePayMethodIsAvailable);
    }
  }, [isAppleDevice, paymentMethods]);

  return isApplePayAvailable;
};
